<div class="search-div">
  <button mat-raised-button color="primary" data-testid="create-experiment-button" (click)="onCreate()"
    [disabled]="!(currentRoles | hasAnyRoles: ['WRITER'] : currentExperiment : 'IsAnyStatus')">
    <mat-icon>add</mat-icon>Create
  </button>
  <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
    <mat-label>Search</mat-label>
    <input matInput type="text" autocomplete="off" data-testid="lp-experiment-search-input" [(ngModel)]="searchKey" (ngModelChange)="onSearchChange()" />
    <button *ngIf="searchKey" matSuffix mat-icon-button data-testid="lp-experiment-search-clear-button" aria-label="Clear search" (click)="onSearchClear()">
      <mat-icon>close</mat-icon>
    </button>
    <mat-icon matSuffix *ngIf="!searchKey">search</mat-icon>
  </mat-form-field>
  <div class="separator"></div>
  <button class="refresh-button" mat-icon-button data-testid="lp-experiment-refresh-button" (click)="loadData()" matTooltip="Refresh the experiments">
    <mat-icon>refresh</mat-icon>
  </button>
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="date-filter-field">
    <mat-label>Show experiments from:</mat-label>
    <mat-select id="date-filter" data-testid="lp-experiment-datefilter-select" [(ngModel)]="experimentMonthFilter" name="date-filter" (selectionChange)="loadData()">
      <mat-option [value]="6"> Last 6 months </mat-option>
      <mat-option [value]="12"> Last year </mat-option>
      <mat-option [value]="0"> All </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-slide-toggle color="primary" data-testid="lp-experiment-showarchived-toggle" [checked]="showArchivedExperiments" (change)="showArchivedExperimentsToggle()">
    Show archived experiments
  </mat-slide-toggle>
</div>
<div class="table-container mat-elevation-z1">
  <mat-table [dataSource]="listData" data-testid="lp-experiment-table" matSort matSortActive="dateCreated" matSortDirection="desc"
    (contentChanged)="tableDataChanged()">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <a [routerLink]="['/experiment-detail', element.experimentId]" [attr.data-testid]="'lp-experiment-name-' + element.experimentId" (click)="onOpenExperiment(element)"
          matTooltip="Open this experiment">
          {{ element.name }}
        </a>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="experimentId">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Exp ID </mat-header-cell>
      <mat-cell *matCellDef="let element" [attr.data-testid]="'lp-experiment-id-' + element.experimentId">{{ element.experimentId | experimentFormat: element.type }}
        <button *ngIf="element.isArchived" mat-icon-button [attr.data-testid]="'lp-experiment-unarchive-button-' + element.experimentId" (click)="onUnarchive(element)"
          matTooltip="Unarchive the experiment"
          [disabled]="!(currentRoles | hasAnyRoles: ['ADMIN', 'WRITER'] : element : 'IsAnyStatus')">
          <mat-icon>unarchive</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="assayName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Assay Name
        <app-column-filter #columnFilter [tableName]="filterTableName" columnName="assayName" displayName="Assay Name"
          [disabled]="loading"></app-column-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.assayName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="protocolNumber">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Protocol Number
        <app-column-filter #columnFilter [tableName]="filterTableName" columnName="protocolNumber"
          displayName="Protocol Number" [disabled]="loading"></app-column-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.protocolNumber }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="replicates">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Replicate No</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.replicates }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="deviceName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Device
        <app-column-filter #columnFilter [tableName]="filterTableName" columnName="deviceName" displayName="Device"
          [disabled]="loading"></app-column-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.deviceName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="expStatus">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Status
        <app-column-filter #columnFilter [tableName]="filterTableName" columnName="expStatus" displayName="Status"
          [disabled]="loading"></app-column-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.expStatus }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="dateCreated">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Date Created</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.dateCreated | date: 'shortDate' }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="createdByName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Created By
        <app-column-filter #columnFilter [tableName]="filterTableName" columnName="createdByName"
          displayName="Created By" [disabled]="loading"></app-column-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.createdByName }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef class="action-column"></mat-header-cell>
      <mat-cell *matCellDef="let row" class="action-column">
        <button mat-icon-button [attr.data-testid]="'lp-experiment-edit-button-' + row.experimentId" (click)="onEdit(row)" matTooltip="{{
            (currentUser | canEditExperiment: currentRoles : row)
              ? 'Edit the experiment'
              : 'View experiment settings'
          }}">
          <mat-icon>{{ 
            (currentUser | canEditExperiment: currentRoles : row) ? 'edit' : 'info_outline'
            }}</mat-icon>
        </button>
        <button mat-icon-button [attr.data-testid]="'lp-experiment-changeowner-button-' + row.experimentId" [matMenuTriggerFor]="menu" matTooltip="Change the owner of the experiment"
          [disabled]="!(currentRoles | hasAnyRoles: ['ADMIN'] : row : 'IsAnyStatus')">
          <mat-icon>manage_accounts</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item data-testid="lp-experiment-changeowner-menuitem-button" *ngFor="let user of accountService.getUsers()" (click)="onChangeOwner(row, user.userId)"
            [value]="user.userId" [disabled]="loading">
            {{ user.displayName }}
          </button>
        </mat-menu>

        <app-note-display [experimentId]="row.experimentId"
          [noteCount]="allExperimentNoteCounts && allExperimentNoteCounts[row.experimentId]"
          [objectID]="row.experimentId" [objectName]="objectName">
        </app-note-display>
        <button *ngIf="!row.isArchived" mat-icon-button [attr.data-testid]="'lp-experiment-archive-button-' + row.experimentId" (click)="onArchive(row)" matTooltip="Archive the experiment"
          [disabled]="!(currentRoles | hasAnyRoles: ['ADMIN', 'WRITER'] : row : 'IsAnyStatus')">
          <mat-icon>archive</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="loading">
      <mat-footer-cell *matFooterCellDef colspan="6"> Loading data... </mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="noData">
      <mat-footer-cell *matFooterCellDef colspan="6"> No data. </mat-footer-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" [attr.data-testid]="'lp-experiment-row-' + row.experimentId"></mat-row>
    <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: listData != null }"></mat-footer-row>
    <mat-footer-row *matFooterRowDef="['noData']"
      [ngClass]="{ hide: !(listData != null && listData.data.length == 0) }"></mat-footer-row>
  </mat-table>
</div>
<mat-paginator class="mat-elevation-z1" data-testid="lp-experiment-paginator" [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"
  showFirstLastButtons></mat-paginator>